import React from 'react';
import { useAppConfigContext } from 'src/viewLayer/components/contexts/AppConfigContext';
import { onForgotPasswordClicked } from 'src/viewLayer/helpers/safeNativeReporter';
import { t } from 'src/viewLayer/helpers/translations';
import { useForgotPasswordPagePath } from 'src/viewLayer/navigation';

import { ForgotPasswordTrackableLink } from './index.styled';

const WebForgotPasswordLink = ({ email }) => {
  const forgotPasswordPath = useForgotPasswordPagePath(email);
  return (
    <ForgotPasswordTrackableLink
      className="ForgotPasswordLink"
      data-testid="forgot-password-link-web"
      href={forgotPasswordPath}
      size="small"
      trackingId="forgot_password_link"
      weight="strong"
    >
      {t('password.links.forgot_password')}
    </ForgotPasswordTrackableLink>
  );
};

const NativeMobileForgotPasswordLink = () => (
  <ForgotPasswordTrackableLink
    className="ForgotPasswordLink"
    data-testid="forgot-password-link-mobile"
    onClick={onForgotPasswordClicked}
    trackingId="forgot_password_link"
    size="small"
    weight="strong"
  >
    {t('password.links.forgot_password')}
  </ForgotPasswordTrackableLink>
);

const ForgotPasswordLink = ({ email }) => {
  const { devicePath } = useAppConfigContext();
  return (
    devicePath === 'login-mobile' ? <NativeMobileForgotPasswordLink /> : <WebForgotPasswordLink email={email} />
  );
};

export default ForgotPasswordLink;
